import gql from 'graphql-tag';

export const USERS_SEARCH = gql`
  query UsersSearch($filterBy: UserFilterInput) {
    users(filterBy: $filterBy) {
      id
      email
      firstName
      lastName
      phone
      street
      street2
      city
      state
      zip
      role {
        name
      }
      venues {
        id
        name
      }
    }
  }
`;
